module.exports = __webpack_public_path__ + "img/switzerland-respiratory-diseases-male.22da74fe.png";